import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { AuthenticationService } from '@mobi/rwc-utils-authentication-jslib';
import { ConfigurationService, Stage } from '@mobi/rwc-utils-ng-jslib';

import { TestUserSelection } from './test-user-selection/test-user-selection';

@Component({
  selector: 'app-login',
  imports: [
    // vendor
    AsyncPipe,

    // local
    TestUserSelection,
  ],
  templateUrl: './login.html',
  styleUrls: ['./login.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Login {
  #oAuthProviderService = inject(AuthenticationService);
  #configService = inject(ConfigurationService);
  #configurationService = inject(ConfigurationService);

  protected isUserLoggedIn$ = this.#oAuthProviderService.isAuthenticated();

  protected logout(): void {
    const redirectUrl = this.#configService.getSync(
      'logoutRedirectUrl'
    ) as string;
    this.#oAuthProviderService.logout({ redirectUrl });
  }

  protected async loginWithAzureAd(): Promise<void> {
    await this.#oAuthProviderService.login();
  }

  protected isStage(stage: Stage): boolean {
    return this.#configurationService.isStage(stage);
  }
}
